import React from 'react';

import './action-button.css';

interface ActionButtonProps {
    children: React.ReactNode;
    onClick: () => void;
    isMenuButton?: boolean;
    width?: string;
}

function ActionButton(props: ActionButtonProps) {
    const { children, onClick, isMenuButton, width } = props;
    return (
        <button
            className={
                isMenuButton ? 'action-button menu-button' : 'action-button'
            }
            onClick={onClick}
            style={{ minWidth: width || 'unset' }}
        >
            <div className="action-button-content">{children}</div>
        </button>
    );
}

export default ActionButton;
